var moduleMap = {
	"./entities-menu": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_app_shared_reducers_locale_app_shared_reducers_locale"), __webpack_require__.e("webpack_sharing_consume_default_app_config_store_app_config_store"), __webpack_require__.e("src_main_webapp_app_entities_menu_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/main/webapp/app/entities/menu */ "./src/main/webapp/app/entities/menu.tsx")))));
	},
	"./entities-routes": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_reduxjs_toolkit_reduxjs_toolkit"), __webpack_require__.e("webpack_sharing_consume_default_app_config_store_app_config_store"), __webpack_require__.e("webpack_sharing_consume_default_app_shared_error_error-boundary-routes_app_shared_error_error-71e9c6"), __webpack_require__.e("src_main_webapp_app_entities_routes_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/main/webapp/app/entities/routes */ "./src/main/webapp/app/entities/routes.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};

__webpack_require__(/*! ./node_modules/.federation/entry.0ba36b45a00eeaf4f547658c3eb42d03.js */ "./node_modules/.federation/entry.0ba36b45a00eeaf4f547658c3eb42d03.js")

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});